import { render, staticRenderFns } from "./sidebar.creative.vue?vue&type=template&id=f3682be4&"
import script from "./sidebar.creative.vue?vue&type=script&lang=js&"
export * from "./sidebar.creative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports